import React from 'react';
import DashboardComponent from '../../../components/admin/dashboard/DashboardComponent';

const Dashboard: React.FC = () => {
  return <DashboardComponent />;
};

export default Dashboard;
